import GenericModel from '../../generic-model';
import { SignConstructionMaterialType } from './sign-construction-material-type';
import { SignConstructionRequirement } from './sign-construction-requirement';

export default class BoardConstructionMaterial extends GenericModel {
  copiedFrom?: SignConstructionRequirement;

  signConstructionMaterialType?: SignConstructionMaterialType;
  signConstructionMaterialLength?: number;
  description?: string;
  amount?: number;
}
